import { useTheme } from '@mui/styles';
import { COLORS } from '../../../utils/Application_Constants';

function TimesheetBreakStyles() {
    const theme = useTheme();

    return {
        breakRow: {
            [theme.breakpoints.up('md')]: {
                flexWrap: 'nowrap',
            },
            zIndex: 0,
            position: 'relative',
        },
        firstBreakCell: {
            [theme.breakpoints.down('md')]: {
                display: 'none',
            },
            '&:nth-child(4)': {
                '& .MuiInputBase-input': {
                    borderTopLeftRadius: '8px',
                    [theme.breakpoints.up('md')]: {
                        borderTopLeftRadius: '8px',
                        borderBottomLeftRadius: '8px',
                    },
                    [theme.breakpoints.down('md')]: {
                        borderTopLeftRadius: '0px',
                    },
                },
            },
        },
        menuButtonCell: {
            border: `1px solid ${COLORS.LT_MIDNIGHT5}`,
            padding: '2px',
            borderTopRightRadius: '8px',
            borderBottomRightRadius: '8px',
            overflow: 'hidden',
            background: COLORS.LT_JOURNEY10,
        },
        disabledBackgroundColor: {
            background: COLORS.LT_MIDNIGHTBG2,
        },
        formControl: {
            marginBottom: '0',
            [theme.breakpoints.up('md')]: {
                '& .MuiOutlinedInput-notchedOutline': {
                    borderColor: 'transparent',
                    borderRadius: '8px',
                },
            },
        },
        menuButton: {
            color: COLORS.TRUE_BLUE,
        },
        menuIcon: {
            color: COLORS.LT_MIDNIGHT25,
            display: 'flex',
            alignItems: 'center',
        },
        menuIconRemove: {
            color: COLORS.LT_PEPPER,
        },
        inputRoot: {
            '&$disabled $notchedOutline': {
                borderColor: 'transparent',
            },

            '&$disabled $input': {
                background: COLORS.LT_MIDNIGHTBG2,
                color: COLORS.LT_MIDNIGHT33,
            },
        },
        disabled: {},
        notchedOutline: {},
        input: {
            padding: '16px !important',
            height: 'auto',
            fontSize: '14px',
            lineHeight: '20px',
            border: `1px solid ${COLORS.LT_MIDNIGHT5}`,
            [theme.breakpoints.up('md')]: {
                borderRight: 'none',
                '&::placeholder': {
                    opacity: 0,
                },
            },
            '&$disabled': {
                background: COLORS.LT_MIDNIGHTBG2,
            },
            '&[type="time"]': {
                height: '20px',
            },
        },
        mobileMenuButton: {
            display: 'none',
        },
        midBreakConnector: {
            position: 'absolute',
            height: '35px',
            width: '600px',
            borderRight: '1px solid #EEF0F1',
            right: '28px',
            borderBottom: '1px solid #EEF0F1',
            bottom: '52%',
            zIndex: -1,
        },
        endBreakConnector: {
            position: 'absolute',
            height: '6em',
            borderRight: '1px solid #EEF0F1',
            right: '28px',
            borderBottom: '1px solid #EEF0F1',
            bottom: '0%',
            zIndex: -1,
        },
        midBreakConnectorContainer: {
            height: '3.5em',
            position: 'relative',
        },
        connectorGrid: {
            flexGrow: '1',
            maxWidth: '100%',
            flexBasis: '25%',
            zIndex: -1,
            backgroundColor: COLORS.WHITE,
            [theme.breakpoints.down('md')]: {
                display: 'none',
            },
        },
        endBreakConnectorContainer: {
            height: '4em',
            position: 'absolute',
            right: '0%',
        },
        menuGrid: {
            backgroundColor: COLORS.WHITE,
            zIndex: 1,
            [theme.breakpoints.down('md')]: {
                display: 'none',
            },
        },
        entryCell: {
            [theme.breakpoints.down('md')]: {
                marginBottom: '12px',
            },
        },
        inputLabel: {
            [theme.breakpoints.up('md')]: {
                display: 'none',
            },
            [theme.breakpoints.down('md')]: {
                color: COLORS.RAVEN,
            },
        },
        unitsGrid: {
            [theme.breakpoints.down('md')]: {
                display: 'none',
            },
        },
        breakMobileHeaderText: {
            [theme.breakpoints.up('md')]: {
                display: 'none',
            },
            [theme.breakpoints.down('md')]: {
                color: COLORS.LT_JOURNEY,
                marginTop: '12px',
            },
        },
        breakMobileHeader: {
            [theme.breakpoints.up('md')]: {
                display: 'none',
            },
        },
        breakDivider: {
            marginBottom: '4px',
            marginTop: '4px',
        },
        breakDeleteButton: {
            width: '100%',
            marginTop: '4px',
            marginBottom: '8px',
        },
    };
}

export default TimesheetBreakStyles;
